import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { Button, Form, Input, message, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { validatePassword } from '../../../../common/commonfunctions';
import SuccessModel from '../../../child-components/success-model/successModal';
import { useDispatch, useSelector } from 'react-redux';
import { ChangePasswordApi, resetChangePassword } from '../../../../redux/features/auth/ChangePassword';
import { decodeToken } from 'react-jwt';
import { encryptInput } from '../../../../shared/shared-functions';
import { RiLockPasswordLine } from 'react-icons/ri';
import { FaWindowClose } from 'react-icons/fa';
import './changePassword.css';

interface props {
	trigger: any;
	disMdl: any;
}
const ChangePassword = ({ trigger, disMdl }: props) => {
	const [openPasswordMdl, setOpenPasswordMdl] = useState<boolean>(true),
		dis = disMdl,
		[form] = Form.useForm(),
		[currentPassword, setCurrentPassword] = useState(''),
		[newPassword, setNewPassword] = useState(''),
		[confirmPassword, setConfirmPassword] = useState(''),
		[isButtonDisabled, setIsButtonDisabled] = useState(true),
		[successMdlDis, setSuccessMdlDis] = useState<boolean>(false),
		dispatch = useDispatch(),
		[decodedToken, setDecodedToken] = useState<any>(),
		{ changePassRes, changePassLoad } = useSelector((state: any) => state.changePassword);


		const authUser: any | null = localStorage.getItem("authUser") 
		? JSON.parse(localStorage.getItem("authUser") as string) 
		: null;

	useEffect(() => {}, [dis]);
	const handleCancel = () => {
		trigger(false);
		setOpenPasswordMdl(false);
	};

	const successMdlOpen = (boolVal: boolean) => {
		setSuccessMdlDis(boolVal);
		trigger(false);
	};

	useEffect(() => {
		// const token = sessionStorage.getItem('accessToken');
		// const token = authUser?.value?.AUTHTOKEN;

		// if (token) {
		// 	const decodedToken: any = decodeToken(token);
		// 	setDecodedToken(decodedToken);
		// }
	}, []);

	const onFinishChangePassword = (values: any) => {
		const formData = new URLSearchParams();
		formData.append('UserGuId', authUser?.value?.USERID);
		formData.append('CurrentPassword', encryptInput(values.currentPass));
		formData.append('NewPassword', encryptInput(values.newPass));
		dispatch(ChangePasswordApi(formData));
	};

	const handlePasswordChange = (value: string) => {
		setNewPassword(value);
		updateButtonState(value, confirmPassword);
	};

	const handleConfirmPasswordChange = (value: string) => {
		setConfirmPassword(value);
		updateButtonState(newPassword, value);
	};

	const updateButtonState = (password: string, confirm: string) => {
		const isValid = password && confirm && password === confirm;
		setIsButtonDisabled(!isValid);
	};

	const successTxt = (
		<div style={{ textAlign: 'center' }}>
			<h2 style={{ color: '#0fce6e' }}>Password Changed Successfully!</h2>
			<p className="successMdlSubLine">Your account password has been successfully changed. Please use your new password for next login!</p>
		</div>
	);

	useEffect(() => {
		if (!changePassLoad && changePassRes && changePassRes?.statusCode === 200) {
			setSuccessMdlDis(true);
			dispatch(resetChangePassword());
		} else if (!changePassLoad && changePassRes && changePassRes?.statusCode === 400) {
			message.warning(changePassRes?.message);
			dispatch(resetChangePassword());
		} else if (!changePassLoad && changePassRes && changePassRes?.statusCode === 500) {
			message.error(changePassRes?.message);
			dispatch(resetChangePassword());
		}
	}, [changePassRes, changePassLoad]);

	return (
		<div>
			<Modal
				title={false}
				closable={false}
				maskClosable={false}
				open={openPasswordMdl}
				footer={false}
				width={500}
				onCancel={handleCancel}
				style={{top:"0px",  background: 'transparent', boxShadow: 'none', padding: '20px' }}
			>
				<div style={{ position: 'relative', textAlign: 'center',fontFamily:"NoirPro" }}>
					<img alt="" src="/assets/images/changePassword.png" style={{ width: '70px' }} />
					<span title="Close" onClick={handleCancel} className="closeIcon">
						<FaWindowClose />
					</span>
					<span style={{ fontWeight: 'bold', fontSize: '14px' }}>
						<p style={{ textAlign: 'center',fontFamily:"NoirPro" ,color:"black" }} className="gx-link">
							Change Password
						</p>
					</span>
					<p className="changeSubLine" style={{ marginBottom: '20px' }}>
						Secure your account by updating your password. Choose a strong and unique password to enhance the protection of your data.
					</p>
				</div>

				<Form layout="vertical" form={form} onFinish={onFinishChangePassword} style={{fontFamily:"Noirpro"}}>
					<div>
						<Form.Item
							label="Current Password"
							name="currentPass"
							rules={[
								{
									validator: validatePassword,
									required: true
								}
							]}
						>
							<Input.Password
								prefix={<RiLockPasswordLine />}
								placeholder="Enter current password"
								value={currentPassword}
								onChange={(e) => setCurrentPassword(e.target.value)}
								iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
								onKeyDown={(event: any) => {
									const input = event.target.value;
									if (event.key === ' ' && input.length === 0) {
										event.preventDefault();
									}
								}}
							/>
						</Form.Item>
					</div>
					<div>
						<Form.Item label="Password" name="newPass" rules={[{ validator: validatePassword, required: true }]}>
							<Input.Password
								prefix={<RiLockPasswordLine />}
								placeholder="Enter new password"
								value={newPassword}
								onChange={(e) => handlePasswordChange(e.target.value)}
								iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
								onKeyDown={(event: any) => {
									const input = event.target.value;
									if (event.key === ' ' && input.length === 0) {
										event.preventDefault();
									}
								}}
							/>
						</Form.Item>
					</div>
					<div>
						<Form.Item
							label="Confirm Password"
							name="confirmPass"
							dependencies={['newPass']}
							rules={[
								{
									required: true,
									message: 'Please confirm password.'
								},
								({ getFieldValue }) => ({
									validator(_, value) {
										if (!value || getFieldValue('newPass') === value) {
											return Promise.resolve();
										}
										return Promise.reject(new Error('The passwords do not match.'));
									}
								})
							]}
						>
							<Input.Password
								prefix={<RiLockPasswordLine />}
								placeholder="Confirm new password"
								value={confirmPassword}
								onChange={(e) => handleConfirmPasswordChange(e.target.value)}
								iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
								onKeyDown={(event: any) => {
									const input = event.target.value;
									if (event.key === ' ' && input.length === 0) {
										event.preventDefault();
									}
								}}
							/>
						</Form.Item>
					</div>

					{/* Buttons */}
					<div className="changePass-footer">
						<Button 
						size="small" 
						onClick={handleCancel}   
						className="cancel-button"
	
						>
							Cancel
						</Button>
						<Button 
						size="small"
						className="custom-button"
						//  type="primary" 
						 disabled={isButtonDisabled} htmlType="submit">
							Apply Changes
						</Button>
					</div>
				</Form>
			</Modal>
			{successMdlDis && <SuccessModel redirection={'home'} title={successTxt} disSuccessMdl={true} triggerSuccess={successMdlOpen} />}
		</div>
	);
};
export default ChangePassword;
